import {
  createCreateUseModal,
  Flex,
  PrimaryButton,
  RemoteImage,
  Typography,
  useScreenSize,
} from '@banhala/ui-kit';
import { isWeb } from '../../../utils';
import { getScreenWidth } from '../../../utils/getScreenWidth/getScreenWidth';
import { Keyboard } from 'react-native';
import { useMemo } from 'react';

const createAlertModal = createCreateUseModal({
  modalProps: {
    coverScreen: isWeb,
    style: {
      margin: 0,
      padding: 0,
      justifyContent: 'center',
    },
    deviceWidth: isWeb ? getScreenWidth() : undefined,
    animationIn: 'fadeIn',
    animationOut: 'fadeOut',
    onBackButtonPress() {
      Keyboard?.dismiss();
    },
    onBackdropPress() {
      Keyboard?.dismiss();
    },
  },
  cancelOnBackButtonPress: true,
  cancelOnBackdropPress: true,
});

const HORIZONTAL_MARGIN = 32;
const HORIZONTAL_PADDING = 32;

export const useShowAnonymousLikeCountLimitAlert = createAlertModal(
  ({ confirm }) => {
    const { width: screenWidth } = useScreenSize();
    const imageWidth = useMemo(
      () => screenWidth - HORIZONTAL_PADDING * 2,
      [screenWidth],
    );

    return (
      <Flex.Row
        alignItems={'center'}
        justifyContent={'center'}
        padding={{ horizontal: HORIZONTAL_MARGIN }}
      >
        <Flex
          backgroundColor={'white'}
          borderRadius={12}
          width={screenWidth - HORIZONTAL_MARGIN}
          padding={{
            top: 24,
            bottom: 16,
            horizontal: HORIZONTAL_PADDING * 0.5,
          }}
        >
          <Flex gap={4} alignItems={'center'}>
            <Typography type={'body1-relaxed'} color={'content_tertiary'}>
              상품 5개 찜 완료!
            </Typography>
            <Typography type={'h4'} textAlign={'center'}>
              지금 가입하고{'\n'}더 많은 상품을 만나보세요
            </Typography>
          </Flex>

          <Flex margin={{ vertical: 20 }} alignItems={'center'}>
            <RemoteImage
              uri={
                'https://img.a-bly.com/promotions/first_purchase/anonymous_dialog_image.png'
              }
              width={imageWidth}
              height={imageWidth * (480 / 837)}
            />
          </Flex>
          <PrimaryButton variant={'fill'} onPress={confirm}>
            5초만에 회원가입 / 로그인
          </PrimaryButton>
        </Flex>
      </Flex.Row>
    );
  },
);
